import FieldsService from './fieldsService';

const FieldsServiceInstance = new FieldsService();

if (process.env.NODE_ENV !== 'production') {
  window.FieldsService = FieldsServiceInstance;
}

export default FieldsServiceInstance;
